import React, { useState } from 'react';
import './ChildTabSelector.css';

function ChildTabSelector({ children, onChildSelect }) {
  const [selectedIndex, setSelectedIndex] = useState(0);

  React.useEffect(() => {
    if (children.length > 0) {
      onChildSelect(children[selectedIndex]);
    }
  }, [children, selectedIndex, onChildSelect]);

  if (children.length === 0) {
    return (
      <div className="empty-children">
        <div className="empty-icon">📚</div>
        <h3>No Children Linked</h3>
        <p>Add your child using their Student ID to view their progress</p>
      </div>
    );
  }

  if (children.length === 1) {
    return null; // Don't show selector for single child
  }

  return (
    <div className="child-tab-selector">
      <div className="child-tabs">
        {children.map((child, index) => (
          <button
            key={child.id}
            className={`child-tab ${selectedIndex === index ? 'active' : ''}`}
            onClick={() => setSelectedIndex(index)}
          >
            <div className="child-avatar">
              {child.photoURL ? (
                <img src={child.photoURL} alt={child.fullName} />
              ) : (
                <span>👤</span>
              )}
            </div>
            <div className="child-tab-info">
              <div className="child-number">Child {index + 1}</div>
              <div className="child-name">{child.firstName}</div>
            </div>
            <div className={`child-indicator ${selectedIndex === index ? 'active' : ''}`}></div>
          </button>
        ))}
      </div>
    </div>
  );
}

export default ChildTabSelector;
